import { render, staticRenderFns } from "./MobileLogoutPage.vue?vue&type=template&id=67d2a29d&"
import script from "./MobileLogoutPage.vue?vue&type=script&lang=js&"
export * from "./MobileLogoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports